import { useState } from 'react';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import ApprovalDialogBox from './ApprovalDialogBox';
import RejectUserDialog from './RejectUserDialog';

const PendingInvites = ({ rows, setRows, isDataLoading, setIsDataLoading }) => {
    const pageSize = 10;
    const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState([])

    const columns = [
        {
            field: 'actions',
            headerName: 'Action',
            width: 250,
            headerAlign: 'center',
            filterable: false,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => (
                <div className='buttonContainer_signupRequest'>
                    <Button variant='contained' className='button_signupRequest' color="success" onClick={() => handleApprove(params.row)}>Approve</Button>
                    <Button variant='contained' className='button_signupRequest' color='error' onClick={() => handleReject(params.row)}>Reject</Button>
                </div>
            )
        },
        { field: 'name', headerName: 'Name', width: 180, filterable: true },
        { field: 'email', headerName: 'Email', width: 270, filterable: true },
        { field: 'orgName', headerName: 'Organization', width: 130, filterable: true },
        { field: 'role', headerName: 'Role', width: 110, filterable: true },
        { field: 'countryName', headerName: 'Country', width: 100, filterable: true },
        { field: 'contactNo', headerName: 'Contact Number', width: 200, filterable: true },
        {
            field: 'createdAt',
            headerName: 'Request Date',
            width: 150,
            sortable: true,
            filterable: false,
            valueGetter: (params) => moment(params).format('DD-MMM-YYYY')
        }
    ];

    const handleApprove = (row) => {
        setSelectedUserData(row)
        setOpenApprovalDialog(true);
    };

    const handleReject = (row) => {
        setSelectedUserData(row)
        setOpenRejectDialog(true);
    };

    const pendingRowAdjustment = (data) => {
        let allPendingUsers = [...rows ];
        allPendingUsers = allPendingUsers.filter((user) => user._id !== data._id);
        setRows(allPendingUsers);
        setIsDataLoading(false);
    }

    return (
        <>
            <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row._id}
                className='dataGrid_pendingInvites'
                pageSizeOptions={[pageSize]}
                pagination
                disableRowSelectionOnClick
                loading={isDataLoading}
            />
            <ApprovalDialogBox
                open={openApprovalDialog}
                handleClose={() => setOpenApprovalDialog(false)}
                isEdit={false}
                userData={selectedUserData}
                pendingRowAdjustment={pendingRowAdjustment}
                setKendoDataLoading={setIsDataLoading}
            />
            <RejectUserDialog
                open={openRejectDialog}
                onClose={() => setOpenRejectDialog(false)}
                userData={selectedUserData}
                pendingRowAdjustment={pendingRowAdjustment}
                setKendoDataLoading={setIsDataLoading}
            />
        </>
    );
};

export default PendingInvites;